<div class="modal-header">
  <h4 class="modal-title" id="modal-basic-title">Filing Type</h4>
  <button type="button" class="close" aria-label="Close" (click)="close()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body ey-privacy-notice-body">
  <div class="container-fluid">
    <div class="row">
      <div class="col-12">
        <p class="header">Selecting Local Registry Filing:</p>
        <div class="body">
          <p>Financial statements filed by the company at the Local authorities to comply with local financial regulations.</p>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <p class="header">Selecting Annual Report:</p>
        <div class="body">
          <p>
            The annual report to shareholders is a document used by most public companies to disclose corporate information to their shareholders. The
            annual report on Form 10-K, which must be filed with the SEC, may contain more detailed information about the company’s financial
            condition than the annual report and will include the annual financial statements of the company.
          </p>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-1 modal-exclamation">
        <span class="material-icons error-icon">error</span>
      </div>
      <div class="col-11">
        <div class="body">
          <p>
            If you have selected an annual registry filing type to be used, it will be utilized; otherwise, a local registry filing type will be used if available, and vice versa.
          </p>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-default" (click)="close()">Close</button>
</div>
